import axios from 'axios';
import { Values } from './models';

export const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getAdasImages = async (imei: string, token: string, params = {}) => {
  const response = await axiosConfig.get(`v2/devices/${imei}/adas-calibration-images`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });

  return response.data?.data;
};

export const getMetaDataDevice = async (imei: string, token: string, orgId: string) => {
  const response = await axiosConfig.get(`v2/organizations/${orgId}/devices?imei=${imei}`, { headers: { Authorization: `Bearer ${token}` } });

  return Array.isArray(response.data?.data) ? response.data?.data[0] : undefined;
};

export const getDeviceTelemetry = async (imei: string, token: string) => {
  const response = await axiosConfig.get(`v2/devices/${imei}/telemetry`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data?.data;
};

export const getUserInfo = async (token: string) => {
  const response = await axiosConfig.get(`v2/me`, { headers: { Authorization: `Bearer ${token}` } });

  return response.data?.data;
};

export const calibrateDevice = async (imei: string, values: Values, token: string) =>
  await axiosConfig.put(`v2/devices/${imei}/calibrate-adas`, values, { headers: { Authorization: `Bearer ${token}` } });
